// Brand partners grouped by material category.
// logo: filename in /public/brands (real logo) or null -> rendered as styled wordmark.
export const BRAND_CATEGORIES = [
  {
    category: "Laminates",
    brands: [
      { name: "Merino", logo: "/brands/merino.png" },
      { name: "Greenlam", logo: null },
      { name: "Advance", logo: null },
      { name: "Royale Touche", logo: null },
      { name: "Virgo", logo: null },
    ],
  },
  {
    category: "Plywood",
    brands: [
      { name: "Century Ply", logo: "/brands/centuryply.png" },
      { name: "Greenply", logo: null },
      { name: "Merino", logo: "/brands/merino.png" },
      { name: "Duro", logo: null },
      { name: "Gurjan Gold", logo: null },
    ],
  },
  {
    category: "Hardware",
    brands: [
      { name: "Hettich", logo: null },
      { name: "Häfele", logo: "/brands/hafele.png" },
      { name: "Godrej", logo: null },
      { name: "Ebco", logo: null },
      { name: "Blum", logo: "/brands/blum.png" },
    ],
  },
  {
    category: "Tiles",
    brands: [
      { name: "Kajaria", logo: null },
      { name: "Somany", logo: "/brands/somany.png" },
      { name: "Johnson", logo: "/brands/johnson.png" },
      { name: "Orient Bell", logo: "/brands/orientbell.png" },
      { name: "RAK Ceramics", logo: "/brands/rak.png" },
    ],
  },
  {
    category: "Lights",
    brands: [
      { name: "Philips", logo: "/brands/philips.png" },
      { name: "Havells", logo: null },
      { name: "Panasonic", logo: null },
      { name: "Wipro", logo: "/brands/wipro.png" },
      { name: "Orient Electric", logo: null },
    ],
  },
  {
    category: "Switches",
    brands: [
      { name: "Legrand", logo: null },
      { name: "Anchor Panasonic", logo: null },
      { name: "L&T", logo: "/brands/lt.png" },
      { name: "GM Modular", logo: null },
      { name: "Norisys", logo: null },
    ],
  },
  {
    category: "Cables",
    brands: [
      { name: "Polycab", logo: "/brands/polycab.png" },
      { name: "Finolex", logo: "/brands/finolex.png" },
      { name: "KEI", logo: "/brands/kei.png" },
      { name: "Havells", logo: null },
      { name: "Syska", logo: "/brands/syska.png" },
    ],
  },
];

// De-duplicated flat list for the marquee strip.
export const BRAND_MARQUEE = (() => {
  const seen = new Set();
  const out = [];
  for (const c of BRAND_CATEGORIES) {
    for (const b of c.brands) {
      if (seen.has(b.name)) continue;
      seen.add(b.name);
      out.push(b);
    }
  }
  return out;
})();
